import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";

import { Pagination, Autoplay } from "swiper";
import { Box, Rating, styled, useMediaQuery } from "@mui/material";
import { FormatQuote } from "@mui/icons-material";
import { useContext, useEffect, useState } from "react";
import StatesContext from "../../context/StatesContext";
import { useLocation } from "react-router-dom";
import { useAllReviewsQuery } from "../../helpers/reviewApi";
import Loader from "../Loader/Loader";
import { serviceNames } from "../../constant";


const Review = () => {

    const context = useContext(StatesContext)
    const { darkToggle } = context

    const smallerthen768 = useMediaQuery('(max-width:768px)')

    const [slug, setslug] = useState('')

    const { data: revData, isFetching } = useAllReviewsQuery(slug)

    const location = useLocation()

    useEffect(() => {

        let x = location.pathname
        x = x.split('/')[1]

        let isSlugExist = serviceNames.filter(item => item === x)


        if (isSlugExist.length) {
            setslug(isSlugExist[0])
        }

    }, [location])

    const StyledPortfolioSection = styled(Box)(({ theme }) => ({


        '.swiper-pagination-bullet-active ': {
        },
        '.swiper-pagination-bullet-active-next': {
            backgroundColor: darkToggle && 'white !important',
            opacity: '0.5'
        },
        '.swiper-pagination-bullet-active-prev': {
            backgroundColor: darkToggle && 'white !important',
            opacity: '0.5'
        },

        '.swiper-pagination': {
            position: 'absolute',
            top: smallerthen768 ? '15px' : '0px',
            zIndex: '-1'
        },


    }))


    return (
        <div>
            {isFetching ? <Loader text={'Loading reviews...'} height='40vh' /> : (
                <div>
                    {revData.reviews.length > 0 && (
                        <div className='max-w-screen-2xl mx-auto py-5 md:py-8 px-4 md:px-12'>
                            <div>
                                <h1
                                    className='text-xl md:text-2xl font-bold text-center dark:text-white'
                                >
                                    Cultivating Long-Term <span className='text-yellow-500'>Relationships</span>
                                </h1>
                            </div>
                            <div className='mt-10'>
                                <div>
                                    <div className="md:w-full lg:w-[90%] shadow-sm bg-indigo-100 dark:bg-gray-600 mx-auto mt-8 relative rounded-xl">

                                        <StyledPortfolioSection>
                                            <Swiper

                                                modules={[Pagination, Autoplay]}
                                                pagination={{
                                                    clickable: true,
                                                    dynamicBullets: smallerthen768 ? true : false
                                                }}
                                                spaceBetween={30}
                                                slidesPerView={smallerthen768 ? 1 : 2}
                                                autoplay={{
                                                    pauseOnMouseEnter: true
                                                }}
                                                speed={1000}
                                                style={{
                                                    "--swiper-navigation-size": "25px",
                                                    position: 'relative',
                                                    borderRadius: '20px',
                                                    padding: smallerthen768 ? '25px 20px' : '40px 30px'
                                                }}
                                            >
                                                {revData.reviews.map((item, i) => (
                                                    <SwiperSlide key={i} >
                                                        <div
                                                            className=" px-4 md:gap-7 py-5 h-[280px] relative  lg:h-[280px] bg-[#f2f7fb] dark:bg-gray-700 rounded-xl hover:scale-95 shadow-md duration-1000 cursor-pointer"
                                                            onClick={() => {
                                                                if (item.link) {
                                                                    window.open(item.link)
                                                                }
                                                            }}
                                                        >

                                                            <div>
                                                                <FormatQuote sx={{ transform: 'rotate(180deg)', fontSize: '40px', color: '#757575', transition: 'all 0.6s ease-in-out', '&:hover': { color: 'black' } }} />

                                                                <p className={`text-[15px] sm:text-[16px] line-clamp-4 text-gray-500 dark:text-gray-300 mt-1 italic`}>
                                                                    "{item.desc}"
                                                                </p>
                                                            </div>

                                                            <div className="absolute bottom-0 left-0 right-0">
                                                                <div className="flex items-center gap-2  mt-3 px-4 pb-5">
                                                                    <img src={item.img} alt='img' key={i} className={`h-[55px] w-[55px] rounded-full`} />
                                                                    <div>
                                                                        <h1 className="font-bold  text-xs  dark:text-white">{item.country}</h1>
                                                                        <div className="-ml-[4px]">
                                                                            <Rating name="half-rating" defaultValue={item.rating} size={'small'} precision={0.5} readOnly />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </SwiperSlide>
                                                ))}
                                            </Swiper>
                                        </StyledPortfolioSection>

                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}

export default Review